import { PropsWithChildren, useEffect } from "react";
import { createContext } from "react";
import { useParams } from "react-router";

import { getConfig } from "../../../config.ts";
import { auth } from "../../../providers/FirestoreProvider";
import { useTenantResolution } from "../hooks/useTenantResolution";
import { AuthClient, AuthData } from "../types/auth";
import { FirebaseUserProvider } from "./FirebaseUserProvider";
import { OidcUserProvider } from "./OidcUserProvider";

export const UserAuthContext = createContext<(AuthClient & AuthData) | null>(
  null
);

const UserAuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { orgSlug } = useParams();
  const { tenant, orgData } = useTenantResolution(orgSlug);

  // Ensure auth.tenantId is set for Firebase when tenant is resolved
  useEffect(() => {
    if (tenant.state === "found") {
      auth.tenantId = tenant.tenantId;
    }
  }, [tenant]);

  const config = getConfig();

  const UserProvider = config.auth?.oidcUrl
    ? OidcUserProvider
    : FirebaseUserProvider;

  return (
    <UserProvider tenant={tenant} orgData={orgData} orgSlug={orgSlug}>
      {children}
    </UserProvider>
  );
};

export default UserAuthProvider;
